
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiContentCopyGoogle as ObiContentCopyGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-content-copy-google.js';
 
 
 

 
 export const ObiContentCopyGoogle = createComponent({
   react: React,
   tagName: 'obi-content-copy-google',
   elementClass: ObiContentCopyGoogleElement,
   events: {
     
   }
  });
 
 